import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNokiaComponent } from './simple-icons-nokia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNokiaComponent ],
    exports:      [ SimpleIconsNokiaComponent ],
    bootstrap:    []
})
export class SimpleIconsNokiaModule {}
